import { pinyin } from 'pinyin-pro';

// Tone-number form, no spaces, lowercased — the canonical key for ASR comparison.
// Example: 媽媽 → "ma1ma"
export function toToneNum(text: string): string {
  if (!text) return '';
  try {
    return pinyin(text, { toneType: 'num', type: 'string', removeNonZh: true })
      .toLowerCase()
      .replace(/\s+/g, '');
  } catch {
    return '';
  }
}

// Tone-mark form for human-visible UI. Example: 媽媽 → "mā ma"
export function toToneMark(text: string): string {
  if (!text) return '';
  try {
    return pinyin(text, { toneType: 'symbol', type: 'string', removeNonZh: true });
  } catch {
    return '';
  }
}

// Per-character tone array (1–5, 5 = neutral). Used to color the tone stroke on each hanzi.
// pinyin-pro `type: 'array'` is per-character.
export function tonesForCharacters(text: string): number[] {
  if (!text) return [];
  try {
    const arr = pinyin(text, { toneType: 'num', type: 'array', removeNonZh: false }) as string[];
    return arr.map((p) => {
      const m = p.match(/([1-5])$/);
      return m ? parseInt(m[1], 10) : 5;
    });
  } catch {
    return [];
  }
}

export const TONE_COLORS: Record<number, string> = {
  1: '#4a9bd6', // flat blue
  2: '#4dd672', // rising green
  3: '#d6a04d', // dipping orange
  4: '#d6634d', // falling red
  5: '#9b8db5', // neutral grey-purple
};
